import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import FilterTableHead from "pages/echeck/Echecks/components/FilterTableHead";
import { actions as echeckActions } from "reducers/echecks";
import { useDispatch, useSelector } from "react-redux";

const EmitedEcheckTitleColumns = () => {
    const dispatch = useDispatch();
    const { echeqFilters: filters } = useSelector((state) => state.echecks);

    const changeFilter = (filterName, filterDirecion) => {
        const requestFilters = {
            ...filters,
            orderColumName: filterName,
            orderDirection: filterDirecion,
        };
        dispatch(echeckActions.setEcheqFilters(requestFilters));
        // setSubmitting(true);
        dispatch(echeckActions.filterEcheqList(requestFilters));
    };

    return (
        <>
            <GridTable.Data>
                <I18n component="span" id="echecks.number" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.beneficiary" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.document" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.currency" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.amount" />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.dateEmited" />
                <FilterTableHead
                    filterName="fecha_emision"
                    columnFilter={{
                        filterSelected: filters.orderColumName,
                        directionFilter: filters.orderDirection,
                    }}
                    changeFilter={changeFilter}
                />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.datePayed" />
                <FilterTableHead
                    filterName="fecha_pago"
                    columnFilter={{
                        filterSelected: filters.orderColumName,
                        directionFilter: filters.orderDirection,
                    }}
                    changeFilter={changeFilter}
                />
            </GridTable.Data>
            <GridTable.Data alignX="center">
                <I18n component="span" id="echecks.status" />
            </GridTable.Data>
            <GridTable.Data />
        </>
    );
};

export default EmitedEcheckTitleColumns;
